export default "__VITE_ASSET__DGMw_oKA__"